import { useQuery } from '@tanstack/react-query'

import { useUpFetch } from '../../utils'

export const usePaymentTerms = () => {
  const upFetch = useUpFetch()

  return useQuery({
    queryFn: async () => upFetch<{ data: Array<{ id: number; title: string }> }>(`/payment-terms`),
    queryKey: ['/payment-terms'],
  })
}
